export default "__VITE_ASSET__R51vUReZ__"